<div *ngIf="formGroup.controls['timeRangeGroup']" class="timerange-timepickers">
    <cl-select-time-picker
        [label]="'From: '"
        [showTimepickerDialog]="showTimepickerDialog"
        [parentForm]="this.formGroup.controls['timeRangeGroup']"
        [timeRange]="timeRange"
        startEndMode="start"
        [intervalAsSeconds]="interval">
    </cl-select-time-picker>
    <div
        class="inline-block"
        *ngIf="nullEnds">
            until finished
    </div>
    <div class="inline-block"
         *ngIf="!nullEnds">
         <cl-select-time-picker
            [label]="'To: '"
            [showTimepickerDialog]="showTimepickerDialog"
            [parentForm]="this.formGroup.controls['timeRangeGroup']"
            [timeRange]="timeRange"
            startEndMode="end"
            [intervalAsSeconds]="interval">
        </cl-select-time-picker>
    </div>
</div>
<mat-error
    [ngClass]="textAlertClass"
    *ngIf="this.formGroup.controls['timeRangeGroup']?.errors?.saneTimeRange">
    The start must come before the end!
</mat-error>
